import { RailsAPIBase, type paths } from "../index.client";

export type DismissAppNotificationResponse = NonNullable<
  paths["/api/v1/app_notifications/{id}/dismiss"]["patch"]["responses"][200]["content"]
>["application/json"];

export class AppNotificationsAPIService extends RailsAPIBase {
  async dismiss(id: number): Promise<DismissAppNotificationResponse> {
    const client = await this.getClient();
    const response = await client.PATCH(
      "/api/v1/app_notifications/{id}/dismiss",
      {
        params: { path: { id } },
      }
    );

    if (response.error) {
      throw new Error(
        `Failed to dismiss notification: ${JSON.stringify(response.error)}`
      );
    }
    if (!response.data) {
      throw new Error("Failed to dismiss notification: No data returned");
    }
    return response.data satisfies DismissAppNotificationResponse;
  }
}
